import { BranchOfficeModel } from './branch-office.model';

export class CashierModel {
  public id: number;
  public name: string;
  public paymentOrders: boolean;
  public branchOffice: BranchOfficeModel;
  public externalQrId: number;

  constructor() {
    this.id = 0;
    this.name = '';
    this.paymentOrders = false;
    this.branchOffice = new BranchOfficeModel();
    this.externalQrId = 0;
  }
}
